export default __webpack_public_path__ + "static/media/loader.de7434d9.gif";